import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="md:px-8 px-3 bg-white pt-40">
            <h1 className="text-2xl font-grifter text-[#273046] mb-6">Majorlink Privacy Policy</h1>
            
            <p className="font-aeonikregular text-sm mb-6">
                At Majorlink, we respect the privacy of our users. This privacy policy explains how we collect, use, disclose, and safeguard your information when you use our platform and services.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Collection of Information: We may collect personal identification information (name, email address, phone number, etc.) when you register on our platform.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Use of Information: The information we collect may be used to facilitate transactions, send emails or notifications, improve user experience, and more.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Security: We implement a variety of security measures to ensure the safety of your personal information.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Third-party Disclosure: We do not sell, trade, or transfer your information to external parties without prior consent.
            </p>

            <p className="font-aeonikregular text-sm mb-6">
                Cookies: We use cookies to understand and save user's preferences for future visits.
            </p>

            {/* ... continue with more privacy-related terms as needed ... */}
        </div>
    );
}

export default PrivacyPolicy;
